// Define a function to get color based on voltage level
export function getVoltageColor(voltage: number): string {
  if (voltage >= 765) return "#FF0000" // Red for 765kV+
  if (voltage >= 500) return "#FF6600" // Orange for 500kV+
  if (voltage >= 400) return "#0000FF" // Blue for 400kV+
  if (voltage >= 220) return "#00CC00" // Green for 220kV+
  if (voltage >= 132) return "#9900CC" // Purple for 132kV+
  if (voltage >= 66) return "#996633" // Brown for 66kV+
  return "#999999" // Gray for lower voltages
}

